import {UseDialogStateReturn} from '@/hooks/useDialogState';
import {FormProvider} from 'react-hook-form';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from '@/shadcn_components/ui/dialog';
import {SaveButton} from '@/components/refinedev/action_buttons';
import {ReactNode, useCallback} from 'react';
import { useEditForm } from '@/hooks/refinedev/useEditForm';
import { useCreateForm, UseCreateFormProps } from '@/hooks/refinedev/useCreateForm';

export type CreateDialogProps = {
  title?: string;
  children?: ReactNode;
  dialogState: UseDialogStateReturn;
  onSubmit?: (data: any) => Promise<void> | void;
  closeWhenSubmit?: boolean;
} & Partial<UseCreateFormProps>;

export const CreateDialog = (props: CreateDialogProps) => {
  const {
    // create form props
    resource,
    formProps,
    transformBeforeSave,
    submitDirtyFieldsOnly,
    // dialog props
    dialogState,
    title,
    children,
    closeWhenSubmit = true,
  } = props;

  const form = useCreateForm({resource, formProps, transformBeforeSave, submitDirtyFieldsOnly});

  const {
    handleSubmit,
    refineCore: {onFinish},
  } = form;

  const {onSubmit = onFinish} = props; // default submit is onFinish of refineCore

  const onSubmitDefault = useCallback(
    async submittedData => {
      console.log('create dialog submittedData', submittedData);
      await onSubmit?.(submittedData);

      if (closeWhenSubmit) {
        form.reset();
        dialogState.closeDialog();
      }
    },
    [onSubmit, dialogState, closeWhenSubmit],
  );

  function onOpenChange(open) {
    console.log('dialog open', open);
    if (!open) form.reset();
    dialogState.setOpen(open);
  }

  return (
    <Dialog open={dialogState.open} onOpenChange={onOpenChange}>
      <DialogContent>
        <FormProvider {...form}>
          <form onSubmit={handleSubmit(onSubmitDefault)}>
            <DialogHeader>
              <DialogTitle>{title}</DialogTitle>
              <DialogDescription></DialogDescription>
            </DialogHeader>
            <div className="overflow-y-auto max-h-[calc(100vh-200px)] scroll px-2">{children}</div>
            <DialogFooter className="justify-end mt-4">
              <SaveButton type="button" onClick={handleSubmit(onSubmitDefault)} />{' '}
            </DialogFooter>
          </form>
        </FormProvider>
      </DialogContent>
    </Dialog>
  );
};
